import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Company } from 'src/app/models/data/company';
import { emptyRole, Role } from 'src/app/models/data/role';
import { SystemCapabilityItem } from 'src/app/models/data/systemCapability';
import { Mode } from 'src/app/models/model';
import { ApiService } from 'src/app/services/api.services';
import { AUDIT_LOG_COLUMN_PROPERTY } from 'src/app/app.constants';
import { AppTabNavigationHeaderComponent } from '../../../../../components/navigation-header/app-navigation-header.component';
import { MatTabGroup, MatTab, MatTabContent } from '@angular/material/tabs';
import { QueryStringTabGroupDirective } from '../../../../../directives/query-string-tab-group.directive';
import { RoleDetailCapabilitiesTableComponent } from '../../../../roles/role-detail/role-detail-capabilities-table/role-detail-capabilities-table.component';
import { BreadcrumbLabelDirective } from '../../../../../directives/breadcrumb-label.directive';
import { RoleDetailUserTableComponent } from '../../../../roles/role-detail/role-detail-user-table/role-detail-user-table.component';
import { AuditLogListComponent } from '../../../../audit-log-list/audit-log-list.component';

@Component({
	selector: 'app-company-roles-detail',
	templateUrl: './company-roles-detail.component.html',
	styleUrls: [
		'./company-roles-detail.component.scss',
		'../../../../common/main.scss',
	],
	imports: [
		AppTabNavigationHeaderComponent,
		MatTabGroup,
		QueryStringTabGroupDirective,
		MatTab,
		MatTabContent,
		RoleDetailCapabilitiesTableComponent,
		BreadcrumbLabelDirective,
		RoleDetailUserTableComponent,
		AuditLogListComponent,
	],
})
export class CompanyDetailRoleDetailComponent implements OnInit {
	@Input() company?: Company;
	roleId: string;
	role: Role;
	mode: Mode;
	companyId = '';
	systemCapabilityItems: SystemCapabilityItem[] = [];

	capabilityTableBreadcrumbLabel = '';
	userTableBreadcrumbLabel = '';
	auditLogBreadcrumbLabel = '';

	canAccessAuditLogs: boolean = false;
	hiddenAuditLogColumns = [AUDIT_LOG_COLUMN_PROPERTY];

	constructor(
		private readonly activatedRoute: ActivatedRoute,
		private readonly router: Router,
		private readonly apiService: ApiService
	) {
		this.roleId = this.activatedRoute.snapshot.params.id;
		this.companyId = this.activatedRoute.snapshot.params.companyId;
		this.role =
			this.router.lastSuccessfulNavigation?.extras?.state?.role ?? emptyRole();
		this.mode =
			this.router.lastSuccessfulNavigation?.extras?.state?.mode ??
			Mode.viewOnly;
		this.company = this.router.lastSuccessfulNavigation?.extras?.state?.company;

		if (!this.company && this.companyId) {
			this.apiService.getCompanyById(this.companyId).then((response) => {
				this.company = response.company;
			});
		}
	}

	updateBreadcrumbLabels(): void {
		this.capabilityTableBreadcrumbLabel = `${this.role?.name}`;
		this.userTableBreadcrumbLabel = `${this.role?.name}`;
		this.auditLogBreadcrumbLabel = `${this.role?.name}`;
	}

	async ngOnInit(): Promise<void> {
		const { role, systemCapabilities } = await this.apiService.getRoleById(
			this.roleId
		);
		this.role = role;
		this.systemCapabilityItems = systemCapabilities;

		// Backend determines if audit logs can be viewed based on:
		// 1. Requesting user has audit capability, AND
		// 2. Either requesting user is Sentrilock OR role belongs to requesting user's company
		this.canAccessAuditLogs = this.role?.canViewAuditLogs ?? false;

		this.updateBreadcrumbLabels();
	}
}
